<template>
    <div
        class="flex gap-3 rounded-md border px-4 py-3 text-sm font-medium leading-5"
        :class="[variant.container, centered ? 'items-center' : 'items-start']"
    >
        <span
            v-if="variant.icon"
            class="flex-shrink-0 [&_svg]:fill-current"
            :class="[variant.iconColor, {'mt-0.5': !centered}]"
        >
            <icon :name="variant.icon"/>
        </span>
        <div class="flex-1 min-w-0"><slot/></div>
    </div>
</template>

<script>
    const variants = {
        success: {
            container: 'bg-green-50 border-green-100 text-green-900',
            icon: 'check-circle',
            iconColor: 'text-green-600',
        },
        error: {
            container: 'bg-red-50 border-red-100 text-red-900',
            icon: 'close-circle',
            iconColor: 'text-red-500',
        },
        warning: {
            container: 'bg-orange-50 border-orange-100 text-orange-900',
            icon: 'alert-circle',
            iconColor: 'text-orange-500',
        },
        neutral: {
            container: 'bg-gray-50 border-gray-200 text-gray-900',
            icon: 'info',
            iconColor: 'text-gray-400',
        },
        info: {
            container: 'bg-blue-50 border-blue-100 text-blue-900',
            icon: 'lightbulb',
            iconColor: 'text-blue-500',
        },
    }

    export default {
        props: {
            type: {
                type: String,
            },
            centered: {
                type: Boolean,
                default: false,
            },
        },

        computed: {
            variant() {
                return variants[this.type] ?? {container: 'bg-white border-gray-200 text-gray-800'}
            },
        },
    }
</script>
